export default __webpack_public_path__ + "static/media/Hounslow-01.ba3425ba.jpg";